const prefix = "SCHEDULED_JOB_";

export const EDIT_DELETE = prefix + "EDIT_DELETE";
export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const RUN = prefix + "RUN";
export const RUN_OVERDUE = prefix + "RUN_OVERDUE";
export const VIEW = prefix + "VIEW";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
